import React from 'react'
import down from "../assets/down.png"
import styled from 'styled-components'

function Intro() {
    return (
        <IntCont id='intro'>
            <NameCont>
                Hi, I'm Uruj!
            </NameCont>
            <div>
                Full Stack Developer | AI Solutions Engineer
            </div>
            <a href='#about'>
                <img src={down} />
            </a>
        </IntCont>
    )
}

export default Intro

const IntCont = styled.div`
    height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    div{
        font-size: 2em;
        color:rgb(225, 199, 0);
        font-weight: bold;
        margin-bottom: 20vh;
        padding: 0.5vh;
        background-color: rgba(0, 0, 0, 0.49);
        border-radius: 15px;
        @media(max-width: 767px){
            font-size: 1em;
        }
    }
    img{
        height: 10vh;
        &:hover{
            opacity: 70%;
        }
    }
    a{
        animation: 0.5s infinite alternate slidein;
        @keyframes slidein{
            0%{
                transform: translateY(-20%);
            }
            100%{
                transform: translateY(0);
            }
        }
    }
`

const NameCont = styled.h1`
    font-size: 5em;
    color: white;
    @media(max-width: 767px){
        font-size: 3em;
    }
    @media(max-width: 281px){
        font-size: 2em;
    }
`